// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.moderatorListDisplayManualApprovalToggle {
    display: flex;
    justify-content: center;

    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Moderation/ModeratorList/ModerationListDisplay/moderatorListDisplay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;;IAEvB,eAAe;AACnB","sourcesContent":[".moderatorListDisplayManualApprovalToggle {\n    display: flex;\n    justify-content: center;\n\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
